import React from 'react'
import "./Errormessage.scss"
const Errormessage = (props) => {
  return (
    <div className='errorinput' >
      {props.text}
    </div>
  )
}

export default Errormessage
